module.exports = __webpack_public_path__ + "img/add_theme_desktop_5.74efadb6.png";